import React, { useEffect, useState, createElement } from 'react';
import { Check, CheckCircle, Music, Shield, Star, X, Clock, Gift, Download, Users, ChevronDown, ChevronUp, AlertCircle, Lock, CreditCard, Zap, PlayCircle, BadgeCheck, MapPin, ArrowRight } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
import { TestimonialCard } from '../components/TestimonialCard';
import { PurchaseNotification } from '../components/PurchaseNotification';
function CheckCircleIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-43">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-44" />
    </svg>;
}
export function LandingPage() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 11,
    minutes: 59,
    seconds: 59
  });
  const [spotsLeft, setSpotsLeft] = useState(17);
  const [viewers, setViewers] = useState(124);
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  // Meta Pixel Integration
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1170774765082882');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1170774765082882&ev=PageView&noscript=1" />`;
    document.body.appendChild(noscript);
    return () => {
      // Cleanup if needed
    };
  }, []);
  // Countdown Timer Logic
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  // Dynamic Social Proof Logic
  useEffect(() => {
    const interval = setInterval(() => {
      setViewers(prev => Math.min(prev + Math.floor(Math.random() * 3) - 1, 150));
      if (Math.random() > 0.7 && spotsLeft > 3) {
        setSpotsLeft(prev => prev - 1);
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [spotsLeft]);
  const features = ['Entender la música paso a paso', 'Participar más en clase', 'Disfrutar las clases de verdad', 'Mejorar presentaciones y actos', 'Aprender jugando y riendo', 'Sentirse seguros y capaces'];
  const teacherBenefits = ['Ahorrar +10 horas TODAS las semanas', 'Dejar de improvisar para siempre', 'Tener respaldo profesional completo', 'Cubrir el 100% del programa anual', 'Dar clases más dinámicas y divertidas', 'Volver a disfrutar tu vocación'];
  const faqs = [{
    question: '¿El material es digital o físico?',
    answer: 'Todo el contenido es 100% digital y descargable. Lo recibís inmediatamente en tu email. Podés usarlo desde la compu, celular o tablet, e imprimir todo lo que necesites para tus alumnos. ¡Sin gastos de envío ni demoras!'
  }, {
    question: '¿Cómo recibo el MegaPack?',
    answer: 'Es automático: Apenas se confirma tu pago (cuestión de segundos), recibís un email con tu acceso exclusivo para descargar todo el material. No esperás envíos ni dependés de nadie. ¡Empezás a usarlo hoy mismo!'
  }, {
    question: '¿Sirve para todos los niveles?',
    answer: '¡Sí, absolutamente! Incluye material específicamente organizado para: Maternal, Preescolar, Inicial, Primaria y Secundaria (1° a 6°). Cada nivel tiene sus carpetas separadas y listas para usar.'
  }, {
    question: '¿Necesito experiencia previa?',
    answer: 'Para nada. El MegaPack está diseñado "a prueba de dudas". Las guías pedagógicas te explican cómo aplicar cada recurso paso a paso, incluso si recién estás empezando en la docencia.'
  }, {
    question: '¿Puedo usarlo en clases presenciales y virtuales?',
    answer: 'Sí, es 100% versátil. Podés proyectarlo en clases presenciales, compartir pantalla en Zoom/Meet, o imprimir las fichas para trabajar en el aula. Se adapta a tu modalidad de trabajo.'
  }, {
    question: '¿Cuánto tiempo tengo acceso?',
    answer: 'Tu acceso es ILIMITADO y DE POR VIDA. Lo pagás una sola vez y es tuyo para siempre. Incluye todas las actualizaciones futuras gratis.'
  }, {
    question: '¿Qué pasa si no me gusta o no me sirve?',
    answer: 'Tenés nuestra GARANTÍA DE HIERRO de 7 días. Si sentís que no es para vos, nos escribís un simple email y te devolvemos el 100% de tu dinero en 24 horas. Sin preguntas, sin vueltas y sin letra chica. El riesgo es todo nuestro.'
  }];
  return <div className="min-h-screen bg-gray-50 font-sans text-gray-900 overflow-x-hidden" data-id="element-45">
      <PurchaseNotification data-id="element-46" />

      {/* Sticky Announcement Bar */}
      <div className="sticky top-0 z-50 bg-gradient-to-r from-blue-600 to-blue-700 text-white text-center py-2 px-4 shadow-md" data-id="element-47">
        <div className="flex items-center justify-center gap-2 text-xs md:text-sm font-bold animate-pulse-slow" data-id="element-48">
          <Clock className="w-4 h-4" data-id="element-49" />
          <span data-id="element-50">🔥 ÚLTIMAS HORAS: 70% DE DESCUENTO + BONOS GRATIS</span>
          <span className="hidden md:inline" data-id="element-51">|</span>
          <span className="hidden md:inline bg-white/20 px-2 py-0.5 rounded text-white" data-id="element-52">
            Termina en: {timeLeft.hours.toString().padStart(2, '0')}:
            {timeLeft.minutes.toString().padStart(2, '0')}:
            {timeLeft.seconds.toString().padStart(2, '0')}
          </span>
        </div>
      </div>

      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 p-3 z-40 md:hidden shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] flex items-center justify-between gap-3" data-id="element-53">
        <span className="text-xs text-red-600 font-bold animate-pulse" data-id="element-54">
          🔥 Quedan {spotsLeft} cupos
        </span>
        <a href="#checkout" className="bg-orange-500 text-white font-bold py-3 px-8 rounded-lg shadow-lg text-sm flex-1 text-center" data-id="element-55">
          LO QUIERO YA
        </a>
      </div>

      {/* Hero Section */}
      <header className="bg-white pb-12 pt-8 px-4 md:px-8 lg:px-16 overflow-hidden relative" data-id="element-56">
        {/* Background decorative elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-5 pointer-events-none" data-id="element-57">
          <div className="absolute top-10 left-10 text-9xl" data-id="element-58">♪</div>
          <div className="absolute bottom-20 right-10 text-8xl" data-id="element-59">♫</div>
          <div className="absolute top-40 right-20 text-6xl" data-id="element-60">♩</div>
        </div>

        <div className="max-w-6xl mx-auto text-center relative z-10" data-id="element-61">
          {/* Social Proof Badge */}
          <div className="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 rounded-full px-4 py-1.5 mb-6 shadow-sm animate-fade-in-up" data-id="element-62">
            <div className="flex -space-x-2" data-id="element-63">
              {[1, 2, 3, 4].map(i => <div key={i} className="w-6 h-6 rounded-full bg-gray-200 border-2 border-white overflow-hidden" data-id="element-64">
                  <img src={`https://i.pravatar.cc/100?img=${i + 10}`} alt="User" className="w-full h-full object-cover" data-id="element-65" />
                </div>)}
            </div>
            <div className="flex items-center gap-1" data-id="element-66">
              <div className="flex text-yellow-400" data-id="element-67">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-68" />)}
              </div>
              <span className="text-xs font-bold text-blue-900" data-id="element-69">
                4.9/5 (+5,000 docentes)
              </span>
            </div>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-blue-900 mb-4 tracking-tight leading-[1.1] drop-shadow-sm" data-id="element-70">
            🎶 MEGAPACK{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-blue-400" data-id="element-71">
              MÚSICA LISTA™
            </span>
          </h1>

          <p className="text-xl md:text-3xl text-orange-600 font-bold mb-6 max-w-3xl mx-auto leading-snug" data-id="element-72">
            Todo tu año de Música resuelto en un solo click.
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-8" data-id="element-73">
            <div className="relative mx-auto max-w-[280px] md:max-w-[400px] transform hover:scale-105 transition-transform duration-500 animate-float" data-id="element-74">
              <div className="absolute inset-0 bg-blue-500 rounded-full blur-[60px] opacity-20 animate-pulse" data-id="element-75"></div>
              <img src="https://cdn.magicpatterns.com/uploads/5AHTgg8bxWwbEujLWhwGXz/PROYECTOS_Anuales_(1).png" alt="Megapack Música Lista Producto Principal" className="relative z-10 w-full drop-shadow-2xl" data-id="element-76" />
              {/* Floating Badge */}
              <div className="absolute -top-4 -right-4 bg-red-600 text-white font-bold rounded-full w-20 h-20 flex flex-col items-center justify-center shadow-lg rotate-12 z-20 border-4 border-white animate-bounce-subtle" data-id="element-77">
                <span className="text-xs" data-id="element-78">AHORRA</span>
                <span className="text-xl" data-id="element-79">70%</span>
              </div>
            </div>
          </div>

          <div className="space-y-4 mb-8" data-id="element-80">
            <p className="text-lg md:text-2xl text-gray-700 font-medium max-w-2xl mx-auto" data-id="element-81">
              Sin improvisar. Sin perder horas.{' '}
              <span className="bg-yellow-100 px-1" data-id="element-82">Sin estrés.</span>
            </p>
            <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-83">
              El sistema definitivo de material musical listo para usar en todos
              los niveles educativos (Inicial, Primaria y Secundaria).
            </p>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-84">
            <div className="text-orange-600 font-bold text-sm animate-pulse flex items-center gap-2" data-id="element-85">
              <Clock className="w-4 h-4" data-id="element-86" />
              La oferta termina en: {timeLeft.hours}:{timeLeft.minutes}:
              {timeLeft.seconds}
            </div>

            <CTAButton size="large" subtext="Acceso inmediato - Garantía de 7 días" pulse={true} data-id="element-87">
              QUIERO MI MEGAPACK AHORA
            </CTAButton>

            <div className="flex flex-wrap justify-center gap-4 mt-4 text-xs md:text-sm text-gray-500 font-medium" data-id="element-88">
              <span className="flex items-center gap-1" data-id="element-89">
                <CheckCircle className="w-4 h-4 text-blue-500" data-id="element-90" /> Descarga
                Inmediata
              </span>
              <span className="flex items-center gap-1" data-id="element-91">
                <Shield className="w-4 h-4 text-blue-500" data-id="element-92" /> Garantía 7 Días
              </span>
              <span className="flex items-center gap-1" data-id="element-93">
                <Lock className="w-4 h-4 text-blue-500" data-id="element-94" /> Pago Seguro
              </span>
            </div>
          </div>
        </div>
      </header>

      {/* Urgency Bar */}
      <div className="bg-blue-50 border-y border-blue-200 py-3 px-4" data-id="element-95">
        <div className="max-w-4xl mx-auto flex items-center justify-center gap-2 text-center" data-id="element-96">
          <AlertCircle className="w-5 h-5 text-blue-600 animate-pulse" data-id="element-97" />
          <p className="text-sm md:text-base text-blue-800 font-medium" data-id="element-98">
            <span className="font-bold" data-id="element-99">¡Atención!</span> Solo quedan{' '}
            <span className="font-bold text-orange-600 underline" data-id="element-100">
              {spotsLeft} cupos
            </span>{' '}
            disponibles con el 70% de descuento.
          </p>
        </div>
      </div>

      {/* Problem Section */}
      <section className="py-16 px-4 bg-gray-100 relative overflow-hidden" data-id="element-101">
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-102">
          <h2 className="text-2xl md:text-4xl font-bold text-center text-gray-800 mb-10" data-id="element-103">
            Si sos docente de Música, esto te va a sonar muy familiar…
          </h2>

          <div className="bg-white p-8 md:p-10 rounded-3xl shadow-xl border-l-8 border-blue-500 space-y-6 transform hover:-translate-y-1 transition-transform duration-300" data-id="element-104">
            <div className="space-y-4" data-id="element-105">
              <div className="flex items-start gap-4" data-id="element-106">
                <div className="bg-blue-100 p-2 rounded-full text-blue-600 mt-1" data-id="element-107">
                  <X className="w-5 h-5" data-id="element-108" />
                </div>
                <p className="text-lg text-gray-700" data-id="element-109">
                  Llegás a tu casa cansado/a después de todo el día…
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-110">
                <div className="bg-blue-100 p-2 rounded-full text-blue-600 mt-1" data-id="element-111">
                  <X className="w-5 h-5" data-id="element-112" />
                </div>
                <p className="text-lg text-gray-700" data-id="element-113">
                  Sabés que tenés que planificar para mañana…
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-114">
                <div className="bg-blue-100 p-2 rounded-full text-blue-600 mt-1" data-id="element-115">
                  <X className="w-5 h-5" data-id="element-116" />
                </div>
                <p className="text-lg text-gray-700" data-id="element-117">
                  Abrís la compu y la hoja está en blanco…
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-118">
                <div className="bg-blue-100 p-2 rounded-full text-blue-600 mt-1" data-id="element-119">
                  <X className="w-5 h-5" data-id="element-120" />
                </div>
                <p className="text-lg font-bold text-gray-900" data-id="element-121">
                  Y empezás otra vez de cero.
                </p>
              </div>
            </div>

            <div className="pt-4 border-t border-gray-100" data-id="element-122">
              <p className="text-gray-600 italic text-center" data-id="element-123">
                "Buscando partituras. Buscando canciones. Buscando ideas.
                Buscando actividades que funcionen..."
              </p>
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-124">
            <p className="text-xl md:text-2xl text-gray-800 mb-8 font-medium" data-id="element-125">
              No es tu culpa. El sistema te exige demasiado.
            </p>
            <div className="bg-blue-600 text-white p-6 md:p-8 rounded-2xl inline-block shadow-lg max-w-2xl transform rotate-1 hover:rotate-0 transition-transform duration-300" data-id="element-126">
              <p className="text-xl md:text-2xl font-bold" data-id="element-127">
                👉 Necesitás un sistema que trabaje por vos, no más trabajo.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* The Solution */}
      <section className="py-20 px-4 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white relative overflow-hidden" data-id="element-128">
        <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[url('https://www.transparenttextures.com/patterns/musical.png')]" data-id="element-129"></div>

        {/* Animated background shapes */}
        <div className="absolute top-20 left-10 w-32 h-32 bg-blue-500 rounded-full blur-3xl opacity-20 animate-pulse-slow" data-id="element-130"></div>
        <div className="absolute bottom-20 right-10 w-40 h-40 bg-purple-500 rounded-full blur-3xl opacity-20 animate-pulse-slow" data-id="element-131"></div>

        <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-132">
          <span className="inline-block bg-orange-500 text-white px-6 py-2 rounded-full text-sm md:text-base font-bold mb-8 tracking-wide uppercase shadow-lg animate-bounce-subtle" data-id="element-133">
            ✨ La Solución Definitiva
          </span>
          <h2 className="text-4xl md:text-6xl font-extrabold mb-8 leading-tight" data-id="element-134">
            🎼 MEGAPACK MÚSICA LISTA™
          </h2>
          <p className="text-xl md:text-2xl text-blue-100 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-135">
            La biblioteca digital más completa de Latinoamérica.{' '}
            <br className="hidden md:block" data-id="element-136" />
            <span className="text-yellow-400 font-bold" data-id="element-137">
              Nunca más empieces de cero.
            </span>
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 text-center mb-12" data-id="element-138">
            {[{
            icon: Check,
            text: 'Todo listo',
            sub: 'Para imprimir'
          }, {
            icon: Star,
            text: 'Todo probado',
            sub: 'En el aula'
          }, {
            icon: Zap,
            text: 'Todo ordenado',
            sub: 'Por niveles'
          }, {
            icon: Users,
            text: 'Todo usable',
            sub: 'Inmediatamente'
          }].map((item, idx) => <div key={idx} className="bg-white/10 p-6 rounded-2xl backdrop-blur-md border border-white/20 hover:bg-white/20 transition-colors duration-300" data-id="element-139">
                <item.icon className="w-10 h-10 text-orange-400 mx-auto mb-3" data-id="element-140" />
                <p className="font-bold text-lg" data-id="element-141">{item.text}</p>
                <p className="text-sm text-blue-200" data-id="element-142">{item.sub}</p>
              </div>)}
          </div>

          <CTAButton variant="primary" size="large" showIcon={true} pulse={true} data-id="element-143">
            QUIERO ACCESO INMEDIATO
          </CTAButton>
        </div>
      </section>

      {/* What's Included */}
      <section className="py-16 px-4 bg-white" data-id="element-144">
        <div className="max-w-6xl mx-auto" data-id="element-145">
          <h2 className="text-3xl md:text-5xl font-bold text-center text-gray-900 mb-4" data-id="element-146">
            ¿Qué incluye exactamente?
          </h2>
          <p className="text-center text-gray-500 mb-12 text-lg" data-id="element-147">
            Todo lo que necesitás para brillar en el aula
          </p>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-148">
            <div className="order-2 lg:order-1" data-id="element-149">
              <div className="bg-orange-50 p-8 rounded-3xl mb-8 border border-orange-100 shadow-sm" data-id="element-150">
                <h3 className="text-2xl md:text-3xl font-bold text-orange-600 mb-2 flex items-center gap-2" data-id="element-151">
                  📚 +90 Recursos Digitales
                </h3>
                <p className="text-gray-700 font-medium" data-id="element-152">
                  Una biblioteca completa valorada en más de $150.000 ARS a tu
                  disposición.
                </p>
              </div>

              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-6" data-id="element-153">
                {['🎼 Partituras listas para usar', '🎶 Cancioneros organizados', '🥁 Juegos rítmicos divertidos', '🎨 Proyectos Música + Arte', '📝 Evaluaciones y rúbricas', '📋 Planillas docentes editables', '📚 Guías pedagógicas paso a paso', '📆 Planificaciones anuales'].map((item, idx) => <li key={idx} className="flex items-center text-gray-700 bg-gray-50 p-3 rounded-lg hover:bg-blue-50 transition-colors" data-id="element-154">
                    <div className="w-6 h-6 bg-blue-500 rounded-full mr-3 flex items-center justify-center shrink-0" data-id="element-155">
                      <Check className="w-3 h-3 text-white" data-id="element-156" />
                    </div>
                    <span className="font-medium" data-id="element-157">{item}</span>
                  </li>)}
              </ul>

              <div className="mt-10 pt-8 border-t border-gray-100" data-id="element-158">
                <h4 className="font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-159">
                  <BadgeCheck className="text-blue-500" data-id="element-160" /> Para todo el sistema
                  educativo:
                </h4>
                <div className="flex flex-wrap gap-3" data-id="element-161">
                  <span className="bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-bold shadow-sm" data-id="element-162">
                    👶 Maternal y Preescolar
                  </span>
                  <span className="bg-green-100 text-green-800 px-4 py-2 rounded-full text-sm font-bold shadow-sm" data-id="element-163">
                    👧 Inicial y Primaria
                  </span>
                  <span className="bg-purple-100 text-purple-800 px-4 py-2 rounded-full text-sm font-bold shadow-sm" data-id="element-164">
                    🎼 Secundaria 1° a 5°
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-3xl p-8 flex items-center justify-center relative order-1 lg:order-2 group" data-id="element-165">
              <div className="absolute inset-0 bg-gradient-to-tr from-blue-100 to-orange-100 rounded-3xl opacity-50 group-hover:opacity-70 transition-opacity" data-id="element-166"></div>
              <img src="https://cdn.magicpatterns.com/uploads/5AHTgg8bxWwbEujLWhwGXz/PROYECTOS_Anuales_(1).png" alt="Contenido del Megapack" className="w-full max-w-md drop-shadow-2xl transform group-hover:scale-105 transition-all duration-500 relative z-10" data-id="element-167" />
              {/* Floating badges */}
              <div className="absolute top-10 right-10 bg-white p-3 rounded-xl shadow-lg z-20 animate-bounce-subtle hidden md:block" data-id="element-168">
                <div className="flex items-center gap-2" data-id="element-169">
                  <Download className="text-green-500 w-5 h-5" data-id="element-170" />
                  <span className="font-bold text-sm" data-id="element-171">Descarga PDF</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Grid */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-172">
        <div className="max-w-6xl mx-auto" data-id="element-173">
          <div className="text-center mb-12" data-id="element-174">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-175">
              Resultados Reales
            </h2>
            <p className="text-gray-600" data-id="element-176">
              El impacto inmediato en tu vida docente
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-177">
            {/* Student Benefits */}
            <div className="bg-white p-8 rounded-3xl shadow-lg border-t-8 border-blue-500 hover:shadow-xl transition-shadow duration-300" data-id="element-178">
              <h3 className="text-2xl font-bold text-gray-900 mb-8 flex items-center" data-id="element-179">
                <div className="bg-blue-100 p-3 rounded-full mr-4" data-id="element-180">
                  <Music className="w-6 h-6 text-blue-600" data-id="element-181" />
                </div>
                Tus Alumnos...
              </h3>
              <ul className="space-y-5" data-id="element-182">
                {features.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-183">
                    <CheckCircle className="w-6 h-6 text-blue-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-184" />
                    <span className="text-gray-700 font-medium text-lg" data-id="element-185">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            {/* Teacher Benefits */}
            <div className="bg-white p-8 rounded-3xl shadow-lg border-t-8 border-blue-500 hover:shadow-xl transition-shadow duration-300" data-id="element-186">
              <h3 className="text-2xl font-bold text-gray-900 mb-8 flex items-center" data-id="element-187">
                <div className="bg-blue-100 p-3 rounded-full mr-4" data-id="element-188">
                  <Star className="w-6 h-6 text-blue-600" data-id="element-189" />
                </div>
                Y VOS...
              </h3>
              <ul className="space-y-5" data-id="element-190">
                {teacherBenefits.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-191">
                    <CheckCircle className="w-6 h-6 text-blue-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-192" />
                    <span className="text-gray-700 font-medium text-lg" data-id="element-193">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-16 px-4 bg-white relative" data-id="element-194">
        <div className="max-w-6xl mx-auto" data-id="element-195">
          <div className="text-center mb-16" data-id="element-196">
            <span className="bg-orange-600 text-white font-bold px-6 py-2 rounded-full text-sm uppercase tracking-wider shadow-lg animate-pulse" data-id="element-197">
              🎁 SOLO POR HOY
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mt-6 mb-4" data-id="element-198">
              3 REGALOS EXCLUSIVOS
            </h2>
            <p className="text-xl text-gray-600" data-id="element-199">
              Valor total:{' '}
              <span className="line-through text-gray-400" data-id="element-200">$45.000 ARS</span>{' '}
              <span className="text-orange-600 font-bold" data-id="element-201">GRATIS HOY</span>
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-202">
            {/* Bonus 1 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-100 hover:-translate-y-2 transition-transform duration-300 group" data-id="element-203">
              <div className="relative aspect-square bg-gray-100 overflow-hidden" data-id="element-204">
                <div className="absolute top-4 right-4 bg-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full z-10" data-id="element-205">
                  GRATIS
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/qHr8PnRnn46RR9s6nhwEnS/11.png" alt="Bono 1" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-206" />
              </div>
              <div className="p-6" data-id="element-207">
                <div className="text-sm text-gray-500 mb-2 font-bold" data-id="element-208">
                  Valor: <span className="line-through" data-id="element-209">$15.000</span>
                </div>
                <h3 className="text-xl font-bold text-blue-900 mb-3" data-id="element-210">
                  Partituras del Mundo
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-211">
                  Canciones multiculturales + material internacional listo para
                  usar en actos y fechas especiales.
                </p>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-100 hover:-translate-y-2 transition-transform duration-300 group" data-id="element-212">
              <div className="relative aspect-square bg-gray-100 overflow-hidden" data-id="element-213">
                <div className="absolute top-4 right-4 bg-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full z-10" data-id="element-214">
                  GRATIS
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/aWBhVTfSsEBDK6VW5F1K65/12.png" alt="Bono 2" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-215" />
              </div>
              <div className="p-6" data-id="element-216">
                <div className="text-sm text-gray-500 mb-2 font-bold" data-id="element-217">
                  Valor: <span className="line-through" data-id="element-218">$15.000</span>
                </div>
                <h3 className="text-xl font-bold text-blue-900 mb-3" data-id="element-219">
                  Música Infantil & Bebés
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-220">
                  Kit especial para nivel inicial y maternal. Canciones, juegos
                  y recursos visuales.
                </p>
              </div>
            </div>

            {/* Bonus 3 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-100 hover:-translate-y-2 transition-transform duration-300 group" data-id="element-221">
              <div className="relative aspect-square bg-gray-100 overflow-hidden" data-id="element-222">
                <div className="absolute top-4 right-4 bg-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full z-10" data-id="element-223">
                  GRATIS
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/xfjiTjFUdKJDuecrwA9eiN/13.png" alt="Bono 3" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-224" />
              </div>
              <div className="p-6" data-id="element-225">
                <div className="text-sm text-gray-500 mb-2 font-bold" data-id="element-226">
                  Valor: <span className="line-through" data-id="element-227">$15.000</span>
                </div>
                <h3 className="text-xl font-bold text-blue-900 mb-3" data-id="element-228">
                  Música + Arte + Teatro
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-229">
                  Proyectos creativos integrados para muestras anuales y
                  proyectos institucionales.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing / Checkout Section */}
      <section id="checkout" className="py-20 px-4 bg-gradient-to-b from-blue-900 to-blue-950 text-white relative overflow-hidden scroll-mt-20" data-id="element-230">
        {/* Background effects */}
        <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20" data-id="element-231"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-500 rounded-full blur-[120px] opacity-20" data-id="element-232"></div>

        <div className="max-w-4xl mx-auto relative z-10" data-id="element-233">
          {/* Header */}
          <div className="text-center mb-12" data-id="element-234">
            <span className="inline-block bg-orange-500 text-white px-6 py-2 rounded-full text-sm font-bold mb-6 tracking-wide uppercase shadow-lg animate-pulse" data-id="element-235">
              🔥 OFERTA POR TIEMPO LIMITADO
            </span>
            <h2 className="text-3xl md:text-5xl font-extrabold mb-4" data-id="element-236">
              Conseguí tu MegaPack Ahora
            </h2>
            <p className="text-xl text-blue-200 mb-6" data-id="element-237">
              Acceso de por vida • Garantía de 7 días
            </p>

            {/* Urgency Timer */}
            
          </div>

          {/* Single Pricing Card */}
          <div className="max-w-2xl mx-auto" data-id="element-238">
            <div className="bg-white text-gray-900 rounded-3xl p-8 md:p-12 shadow-2xl relative border-4 border-orange-500" data-id="element-239">
              {/* Badge "Más Elegido" */}
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-orange-500 text-white px-6 py-2 rounded-full text-sm font-bold shadow-lg whitespace-nowrap" data-id="element-240">
                ⭐ +5,000 DOCENTES YA LO TIENEN
              </div>

              <div className="text-center mb-8 mt-2" data-id="element-241">
                <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2" data-id="element-242">
                  MEGAPACK MÚSICA LISTA™
                </h3>
                <p className="text-lg text-orange-600 font-bold" data-id="element-243">
                  Todo tu año resuelto en un solo pago
                </p>
              </div>

              <div className="text-center mb-8" data-id="element-244">
                <div className="flex items-center justify-center gap-2 mb-2" data-id="element-245">
                  <span className="text-lg text-gray-400 line-through" data-id="element-246">
                    Antes $66.990
                  </span>
                  <span className="bg-orange-100 text-orange-700 text-sm font-bold px-3 py-1 rounded" data-id="element-247">
                    AHORRA 70%
                  </span>
                </div>
                <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-248">
                  <span className="text-6xl md:text-7xl font-extrabold text-orange-500" data-id="element-249">
                    $19.990
                  </span>
                  <span className="text-2xl font-bold text-gray-500" data-id="element-250">ARS</span>
                </div>
                <div className="text-sm text-gray-500" data-id="element-251">
                  Pago único • Sin suscripciones
                </div>
              </div>

              <div className="bg-orange-50 border border-orange-200 rounded-xl p-4 mb-6" data-id="element-252">
                <h4 className="font-bold text-gray-900 mb-4 text-center" data-id="element-253">
                  ✨ Todo lo que incluye:
                </h4>
                <ul className="space-y-3 text-sm" data-id="element-254">
                  <li className="flex items-start gap-2" data-id="element-255">
                    <Check className="w-5 h-5 text-orange-500 shrink-0 mt-0.5" data-id="element-256" />
                    <span data-id="element-257">+90 libros y cuadernos digitales</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-258">
                    <Check className="w-5 h-5 text-orange-500 shrink-0 mt-0.5" data-id="element-259" />
                    <span data-id="element-260">Partituras y cancioneros organizados</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-261">
                    <Check className="w-5 h-5 text-orange-500 shrink-0 mt-0.5" data-id="element-262" />
                    <span data-id="element-263">
                      Material para todos los niveles (Maternal a Secundaria)
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-264">
                    <Check className="w-5 h-5 text-orange-500 shrink-0 mt-0.5" data-id="element-265" />
                    <span data-id="element-266">Juegos musicales y actividades didácticas</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-267">
                    <Check className="w-5 h-5 text-orange-500 shrink-0 mt-0.5" data-id="element-268" />
                    <span data-id="element-269">Evaluaciones y rúbricas listas</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-270">
                    <Check className="w-5 h-5 text-orange-500 shrink-0 mt-0.5" data-id="element-271" />
                    <span data-id="element-272">Planificaciones anuales completas</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-273">
                    <Check className="w-5 h-5 text-orange-500 shrink-0 mt-0.5" data-id="element-274" />
                    <span data-id="element-275">Guías pedagógicas paso a paso</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-276">
                    <Check className="w-5 h-5 text-orange-500 shrink-0 mt-0.5" data-id="element-277" />
                    <span className="font-bold" data-id="element-278">
                      3 Bonos Exclusivos GRATIS ($45.000 valor)
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-279">
                    <Check className="w-5 h-5 text-orange-500 shrink-0 mt-0.5" data-id="element-280" />
                    <span data-id="element-281">Descarga ilimitada</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-282">
                    <Check className="w-5 h-5 text-orange-500 shrink-0 mt-0.5" data-id="element-283" />
                    <span className="font-bold" data-id="element-284">Acceso de por vida</span>
                  </li>
                </ul>
              </div>

              <div className="space-y-4" data-id="element-285">
                <div className="text-sm text-orange-600 font-bold text-center animate-pulse" data-id="element-286">
                  🔥 Quedan {spotsLeft} cupos con este precio
                </div>
                <a href="https://checkout.recursospro.shop/cart/47599804809472:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-extrabold text-xl md:text-2xl py-6 rounded-xl shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 text-center border-b-4 border-orange-800" data-id="element-287">
                  👉 SÍ, QUIERO MI MEGAPACK AHORA
                </a>
                <p className="text-sm text-gray-600 text-center" data-id="element-288">
                  Acceso inmediato después del pago • Garantía de devolución de
                  7 días
                </p>
              </div>
            </div>
          </div>

          {/* Trust Signals */}
          <div className="text-center mt-12" data-id="element-289">
            <div className="flex flex-col items-center gap-4" data-id="element-290">
              <div className="flex items-center gap-2 text-sm text-blue-200" data-id="element-291">
                <Lock className="w-4 h-4" data-id="element-292" />
                <span data-id="element-293">Pago 100% seguro procesado por:</span>
              </div>
              <div className="bg-white rounded-xl px-8 py-4 shadow-lg" data-id="element-294">
                <img src="https://http2.mlstatic.com/frontend-assets/ml-web-navigation/ui-navigation/6.6.92/mercadolibre/logo_large_25years@2x.png" alt="Mercado Pago" className="h-8 md:h-10" data-id="element-295" />
              </div>
              <div className="flex flex-wrap justify-center gap-4 text-xs text-blue-300 mt-2" data-id="element-296">
                <span className="flex items-center gap-1" data-id="element-297">
                  <Shield className="w-3 h-3" data-id="element-298" /> Garantía 7 días
                </span>
                <span className="flex items-center gap-1" data-id="element-299">
                  <Download className="w-3 h-3" data-id="element-300" /> Acceso inmediato
                </span>
                <span className="flex items-center gap-1" data-id="element-301">
                  <Users className="w-3 h-3" data-id="element-302" /> +5,000 docentes confían
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 px-4 bg-gray-50" data-id="element-303">
        <div className="max-w-6xl mx-auto" data-id="element-304">
          <div className="text-center mb-16" data-id="element-305">
            <div className="flex justify-center mb-4" data-id="element-306">
              <div className="flex text-yellow-400 gap-1" data-id="element-307">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" data-id="element-308" />)}
              </div>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-309">
              Más de 5,000 docentes felices
            </h2>
            <p className="text-gray-600 text-lg" data-id="element-310">
              Sumate a la comunidad de profes que ya transformaron sus clases
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-311">
            <TestimonialCard name="Laura Fernández" role="Profesora de Música" location="Buenos Aires, Argentina" quote="Me devolvió el control de mi año docente. Ya no paso los domingos planificando, ahora disfruto mi tiempo libre. ¡Vale cada peso!" imageInitials="LF" verified={true} highlight="Ahorró 10hs/semana" data-id="element-312" />
            <TestimonialCard name="Carlos Méndez" role="Docente de Primaria" location="Córdoba, Argentina" quote="Nunca tuve un material tan completo. Mis alumnos están fascinados con las nuevas actividades y yo me siento mucho más seguro en el aula." imageInitials="CM" verified={true} highlight="Alumnos más motivados" data-id="element-313" />
            <TestimonialCard name="Ana García" role="Maestra de Inicial" location="Rosario, Argentina" quote="Mis clases cambiaron por completo. El material es súper fácil de adaptar y usar. Lo compré hace 2 meses y sigo descubriendo recursos nuevos." imageInitials="AG" verified={true} highlight="Material infinito" data-id="element-314" />
          </div>

          <div className="mt-12 text-center" data-id="element-315">
            <div className="inline-flex items-center gap-2 text-gray-500 bg-white px-4 py-2 rounded-full shadow-sm border border-gray-100" data-id="element-316">
              <Users className="w-4 h-4" data-id="element-317" />
              <span className="text-sm font-medium" data-id="element-318">
                124 personas están viendo esta página ahora
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-20 px-4 bg-white relative overflow-hidden" data-id="element-319">
        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-320">
          <div className="bg-blue-50 rounded-[3rem] p-10 md:p-16 border border-blue-100 shadow-sm" data-id="element-321">
            <div className="inline-block p-5 rounded-full bg-white shadow-md mb-8 animate-float" data-id="element-322">
              <Shield className="w-16 h-16 text-blue-600" data-id="element-323" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-324">
              Garantía de Satisfacción "Sin Preguntas"
            </h2>
            <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-325">
              Tenés 7 días completos para probar todo el material. Si por
              CUALQUIER razón sentís que no es lo que esperabas, te devolvemos
              el 100% de tu dinero.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-2xl mx-auto" data-id="element-326">
              <div className="flex flex-col items-center" data-id="element-327">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mb-3" data-id="element-328">
                  <Check className="w-5 h-5 text-blue-600" data-id="element-329" />
                </div>
                <span className="font-bold text-gray-800" data-id="element-330">Riesgo Cero</span>
              </div>
              <div className="flex flex-col items-center" data-id="element-331">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mb-3" data-id="element-332">
                  <Check className="w-5 h-5 text-blue-600" data-id="element-333" />
                </div>
                <span className="font-bold text-gray-800" data-id="element-334">
                  Devolución Rápida
                </span>
              </div>
              <div className="flex flex-col items-center" data-id="element-335">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mb-3" data-id="element-336">
                  <Check className="w-5 h-5 text-blue-600" data-id="element-337" />
                </div>
                <span className="font-bold text-gray-800" data-id="element-338">Sin Letra Chica</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 px-4 bg-gray-50" data-id="element-339">
        <div className="max-w-3xl mx-auto" data-id="element-340">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-341">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-342">
            {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden transition-all duration-300 hover:shadow-md" data-id="element-343">
                <button onClick={() => setOpenFaq(openFaq === idx ? null : idx)} className="w-full px-6 py-5 text-left flex items-center justify-between font-bold text-gray-900 focus:outline-none" data-id="element-344">
                  <span className="text-lg" data-id="element-345">{faq.question}</span>
                  {openFaq === idx ? <ChevronUp className="w-5 h-5 text-blue-500" data-id="element-346" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-347" />}
                </button>
                <div className={`px-6 text-gray-600 overflow-hidden transition-all duration-300 ease-in-out ${openFaq === idx ? 'max-h-48 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-348">
                  {faq.answer}
                </div>
              </div>)}
          </div>

          <div className="mt-12 text-center" data-id="element-349">
            <p className="text-gray-600 mb-4" data-id="element-350">¿Tenés otra duda?</p>
            <a href="mailto:soporte@recursospro.shop" className="text-blue-600 font-bold hover:underline" data-id="element-351">
              Escribinos a soporte@recursospro.shop
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
    </div>;
}